import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getUser, getTokenPayload, logout } from '../api/security'
import UserMenu from '../components/UserMenu'
import Icon from '../components/Icon'
import styles from './Navbar.module.css'

// Maps route paths to breadcrumb labels
const ROUTE_LABELS = {
  '/dashboard':     'Dashboard',
  '/skills':        'Skills',
  '/teams':         'Teams',
  '/cases':         'Cases',
  '/knowledge':     'Knowledge',
  '/connect':       'Connect',
  '/admin':         'Administration',
}

export default function Navbar({ open = false, onOpenDrawer }) {
  const location = useLocation()
  const navigate  = useNavigate()
  const user      = getUser()
  const rights    = getTokenPayload()?.rights
  const menuBtnRef = useRef(null)
  const wasOpenRef = useRef(open)

  const pageLabel = ROUTE_LABELS[location.pathname] ?? ''

  // Return focus to the hamburger once the drawer closes (mobile only).
  useEffect(() => {
    if (wasOpenRef.current && !open) menuBtnRef.current?.focus()
    wasOpenRef.current = open
  }, [open])

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <header className={styles.navbar}>

      {/* Left — hamburger (mobile only) + breadcrumb */}
      <div className={styles.leftSlot}>
        <button
          ref={menuBtnRef}
          className={styles.menuBtn}
          onClick={onOpenDrawer}
          aria-label="Open navigation menu"
        >
          <Icon name="menu" />
        </button>
        <div className={styles.breadcrumb}>
          <span className={styles.homeIcon}>
            <Icon name="home" />
          </span>
          {pageLabel && (
            <>
              <span className={styles.separator}>»</span>
              <span className={styles.pageLabel}>{pageLabel}</span>
            </>
          )}
        </div>
      </div>

      {/* Right — notifications + account menu */}
      <div className={styles.rightSlot}>

        {/* Notification bell */}
        <button className={styles.iconBtn} aria-label="Notifications">
          <Icon name="bell" />
          <span className={styles.notifDot} />
        </button>

        {/* Account menu (avatar + hover tooltip + popover with logout) */}
        <UserMenu user={user} rights={rights} onLogout={handleLogout} />

      </div>
    </header>
  )
}